// extracted by mini-css-extract-plugin
export var column = "SessionPage-module--column--f8385";
export var content = "SessionPage-module--content--63bec";
export var logo = "SessionPage-module--logo--d66c4";
export var page = "SessionPage-module--page--e9774";